import { CheckCircleIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router";

export default function ThanksPage() {
  return (
    <main className="container mx-auto font-light text-black dark:text-white">
      <h1 className="text-3xl px-10 mb-6 text-cyan-900 dark:text-cyan-200">
        Thanks for joining the dev list!
      </h1>
      <div className="my-8 rounded-md bg-green-50 p-4 dark:bg-green-500/10 dark:outline dark:outline-green-500/20">
        <div className="flex">
          <div className="shrink-0">
            <CheckCircleIcon aria-hidden="true" className="size-5 text-green-400" />
          </div>
          <div className="ml-3">
            <p className="text-sm font-medium text-green-800 dark:text-green-300">Successfully subscribed to the newsletter!</p>
          </div>
          <div className="ml-auto pl-3">
            <div className="-mx-1.5 -my-1.5">
              <button
                type="button"
                onClick={() => {
                  window.location.href = "/";
                }}
                className="inline-flex rounded-md bg-green-200 p-1.5 text-green-500 hover:bg-green-100 focus-visible:ring-2 focus-visible:ring-green-600 focus-visible:ring-offset-2 focus-visible:ring-offset-green-50 focus-visible:outline-hidden dark:bg-transparent dark:text-green-400 dark:hover:bg-green-500/10 dark:focus-visible:ring-green-500 dark:focus-visible:ring-offset-1 dark:focus-visible:ring-offset-green-900"
              >
                <span className="sr-only">Dismiss</span>
                <XMarkIcon aria-hidden="true" className="size-5" />
              </button>
            </div>
          </div>
        </div>
      </div>
      <p className="text-lg px-10 mb-6 text-cyan-900 dark:text-cyan-200">
        You'll hear from me soon!
      </p>
      <p className="text-lg px-10 mb-6 text-cyan-900 dark:text-cyan-200">
        You can unsubscribe at any time.
      </p>
    </main>
  )
}
